/* Nombra Studio — fecha estimada de entrega según el día de la compra */
(function () {
  function formato(fecha) {
    try {
      return fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
    } catch (e) {
      return fecha.getDate() + '/' + (fecha.getMonth() + 1);
    }
  }

  function pintarPlazos() {
    document.querySelectorAll('[data-nb-plazo]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var destino = el.querySelector('[data-nb-plazo-texto]');
      if (!destino || isNaN(min) || isNaN(max)) return;
      var hoy = new Date();
      var desde = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + min);
      var hasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + max);
      destino.innerHTML = 'Recíbelo entre el <strong>' + formato(desde) + '</strong> y el <strong>' + formato(hasta) +
        '</strong> <span style="font-weight:500">(' + min + '-' + max + ' días)</span>';
    });
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('.nb-fuente input[type="radio"]')) return;
    var cont = r.closest('.nb-fuentes');
    var oculto = cont && cont.querySelector('[data-nb-codigo]');
    if (oculto) oculto.value = r.getAttribute('data-codigo') || '';
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintarPlazos);
  } else {
    pintarPlazos();
  }
})();
